import OldAppThemeProvider from '../lib/components/design_system/AppThemeProvider';
import AppThemeProvider from '../styles/AppThemeProvider';
import {GlobalStyles} from '../styles/GlobalStyles';
import THEME from '../styles/theme/default';

import React, {ReactNode} from 'react';

const CompatibilityThemeProvider = ({children}: {children: ReactNode}) => {
  return (
    <OldAppThemeProvider>
      <AppThemeProvider theme={THEME}>
        <GlobalStyles />
        {children}
      </AppThemeProvider>
    </OldAppThemeProvider>
  );
};

export default CompatibilityThemeProvider;
